import {BaseDTO} from '../../../common/models/BaseDTO';
import {NameValueDTO} from '../../../common/models/NameValueDTO';

export class ObservationReviewDTO extends BaseDTO {
  observationId: number;
  observationType: NameValueDTO;
  observationValue: string;
  valueType: NameValueDTO;
  effectiveDate: Date;
}
